import { render, staticRenderFns } from "./phoneInput.vue?vue&type=template&id=128397e7&scoped=true&"
import script from "./phoneInput.vue?vue&type=script&lang=js&"
export * from "./phoneInput.vue?vue&type=script&lang=js&"
import style0 from "./phoneInput.vue?vue&type=style&index=0&id=128397e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128397e7",
  null
  
)

export default component.exports